import { render, staticRenderFns } from "./LeaderboardTest.vue?vue&type=template&id=79b63696&scoped=true&"
import script from "./LeaderboardTest.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTest.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardTest.vue?vue&type=style&index=0&id=79b63696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b63696",
  null
  
)

export default component.exports